import styled from 'styled-components'

import { Flex } from '../../../../../layout'

export const SaveAndUndoButtonGroup = styled(Flex)`
  & > button {
    flex-grow: 1;
  }
`
